export default "__VITE_ASSET__b9c182c6__"